import React from 'react';
import { SurveyPagePropTypes, PageNavigation, useNeuroState } from '@ignitesales/neuro-application';
import { getBankSaved } from '../../utils/getBank.js';

const SurveyPage = ({ className, componentClass, renderQuestionGroups }) => {
    const { answers, bankSelected } = useNeuroState();
    const bankTheme = getBankSaved(bankSelected, answers.urlParameters);

    return (
        <div className={className}>
            <div className={`${componentClass}__container container ${bankTheme}`}>
                <div className={`questionGroups ${componentClass}__questionGroups`}>
                    {renderQuestionGroups()}
                </div>
                <PageNavigation innerPrevBtn="< Back" innerNextBtn="Next >" />
            </div>

        </div>
    );
};

SurveyPage.propTypes = SurveyPagePropTypes;

export default SurveyPage;
